import React, { useState , useMemo} from "react";
import { Dialog, DialogContent, Typography, TextField } from "@mui/material";
import { Stack, Button, Box } from "@mui/material";
import { Toast } from "../components/Toast";
import { v4 as uuidv4 } from "uuid";
import { itemNewDesign } from "../features/ItemNewDesign";
import {Checkbox, Container, FormControl,FormControlLabel,InputLabel,Select,MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";

const Input = styled("div")({
  border: "1px solid #4daf51",
  height: "60px",
  padding: "7px",
  borderRadius: "10px",
  boxShadow: "0px 3px 7px #4daf51",
});
function AddBatchNo({ onClose, onSuccess }) {
  const [state, setState] = useState({
    batchNumber: "",
    expiryDate: "",
    quantity: 0,
    box: false,
    piecesPerBox: 0,
    pricePerPiece:0,
    // saleLabel: false,
    newItem: {
      saleLabel: "",
      costPrice: 0,
      price: 0,
      companyPrice: 0,
      whole_sale_price:""
    },
  });
  console.log('stateeeee', state);

  const pricePerBoxHandler  = useMemo(() => {
    const pricePerBox = Number(state.newItem.price) / Number(state.piecesPerBox);
    console.log("priceperbox", pricePerBox);
    setState((prev) => ({ ...prev,pricePerPiece: pricePerBox}));

    return pricePerBox;
  }, [state.newItem.price, state.piecesPerBox]);
  const handleInput = (e) => {
    const { name, value } = e.target;
    if (
      name === "batchNumber" || 
      name === "expiryDate" || 
      name === "quantity" || 
      name === "box" || 
      name === "piecesPerBox"      ) {

        if(name == "quantity" || name == "piecesPerBox") {
          setState((prev) => ({ ...prev, [name]: Number(value) }));
        } else {
          setState((prev) => ({ ...prev, [name]: value }));
        }
  
    } else if(   
      name === "costPrice" || 
      name === "price" || 
      name === "companyPrice" || 
      name === "whole_sale_price" || 
      name === "saleLabel"
    ) {
      if(name == "costPrice" || name == "price") {
        setState((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: Number(value) },
        }));
      } else {
        setState((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: value },
        }));
      }
    
    }
  };



  const handleBox = (e) => {
    let name = e.target.name;
    let value;
    if (name == "box" || name == "createFastCash") {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const handleAdd = () => {
    if (!state.batchNumber) {
      Toast("info", "Add Batch Number");
      return;
    }
    if (!state.expiryDate) {
      Toast("info", "Add Expiry Date");
      return;
    }
    if (state.quantity === "") {
      Toast("info", "Add Quantity");
      return;
    }
    const pricePerPiece = Number(state.newItem.price) / Number(state.piecesPerBox)
   console.log('pricePerPiece',pricePerPiece)
   console.log('pricePerPiece',state)

    const newObj = {
      batchNumber:state.batchNumber,
      expiryDate: state.expiryDate,
      quantity: state.quantity,
      ...((state.box && { box: state.box }) || {}), // Include box only if it is true
      ...((state.piecesPerBox && { piecesPerBox: state.piecesPerBox }) || {}),
      ...((state.piecesPerBox && { piecesPerBox: state.piecesPerBox }) || {}),
      ...(((state.quantity && state.quantity !== null  && state.quantity !== undefined && state.piecesPerBox && state.piecesPerBox !== null  && state.piecesPerBox !== undefined) &&{ totalBoxes: (Number(state.quantity) / Number(state.piecesPerBox)) }) || {}),
      ...(((pricePerPiece && pricePerPiece !== null  && pricePerPiece !== undefined) &&{ pricePerPiece: pricePerPiece }) || {}),

      // saleLabel: false,
      newItem: {
        saleLabel: state.newItem.saleLabel,
        costPrice: state.newItem.costPrice,
        price: state.newItem.price,
        companyPrice: state.newItem.companyPrice,
        whole_sale_price:state.newItem.whole_sale_price
      },
    }
    onSuccess({ ...newObj, _id: uuidv4() });
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing={3}>
          <Typography variant="h6">Add Batch Number</Typography>
          <TextField
            fullWidth
            size="small"
            name="batchNumber"
            label="Batch Number"
            variant="outlined"
            value={state.batchNumber}
            onChange={handleInput}
          />
          <Box>
            <Typography sx={{ textAlign: "left" }}>Expiry Date</Typography>
            <TextField
              fullWidth
              size="small"
              type="date"
              name="expiryDate"
              variant="outlined"
              value={state.expiryDate}
              onChange={handleInput}
            />
          </Box>
          <TextField
            fullWidth
            size="small"
            type="number"
            label="Quantity"
            name="quantity"
            variant="outlined"
            value={state.quantity}
            onChange={handleInput}
          />

{!itemNewDesign() && (
          <Stack alignItems="flex-end">
            <FormControlLabel
              control={
                <Checkbox checked={state.box} name="box" onChange={handleBox} />
              }
              label="Ctn"
            />
          </Stack>
        )}
        {!itemNewDesign() && (
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ gap: { md: "0px", xs: "5px" } }}
          >
            {
             
              <Input>
                <TextField
                  variant="standard"
                  name="costPrice"
                  label={
                    state.box
                      ? state.newItem.saleLabel === "box"
                        ? "Cost Price Per Box"
                        : "Cost Price Per Ctn"
                      : "Cost Price"
                  }
                  value={state.newItem.costPrice}
                  type="Number"
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                  onChange={handleInput}
                />
              </Input>
            }

            <Input>
              <TextField
                variant="standard"
                value={state.newItem.price}
                name="price"
                label={
                  state.box
                    ? state.newItem.saleLabel === "box"
                      ? "Sale Price Per Box"
                      : "Sale Price Per Ctn"
                    : "Sale Price"
                }
                type="Number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
          </Stack>
        )}

{!itemNewDesign() && (
          <>
            {!state.box && (
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ gap: { md: "0px", xs: "5px" } }}
              >
                <Input>
                  <TextField
                    variant="standard"
                    name="companyPrice"
                    label="Company Price"
                    type="Number"
                    value={state.newItem.companyPrice}
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleInput}
                  />
                </Input>

                <Input>
                  <TextField
                    variant="standard"
                    min="1"
                    label="Whole Sale Price"
                    name="whole_sale_price"
                    value={state.newItem.whole_sale_price}
                    type="number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleInput}
                  />
                </Input>
              </Stack>
            )}

{state.box == true && (
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ gap: { md: "0px", xs: "5px" } }}
              >
                <Input>
                  <TextField
                    variant="standard"
                    name="piecesPerBox"
                    label={
                      state.newItem.saleLabel === "box"
                        ? "Pieces Per Box"
                        : "Box Per Ctn"
                    }
                    value={state.piecesPerBox}
                    type="Number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleBox}
                  />
                </Input>
                <Input>
                  <TextField
                    variant="standard"
                    name="pricePerPiece"
                    label={
                      state.newItem.saleLabel === "box"
                        ? "Price Per Piece"
                        : "Price Per Box"
                    }
                    value={pricePerBoxHandler}
                    type="Number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleInput}
                  />
                </Input>
              </Stack>
            )}
          </>
        )}
          {state.box == true && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Select Sale Label</InputLabel>
              <Select
                variant="standard"
                name="saleLabel"
                defaultValue=""
                onChange={handleInput}
                // value={newItem.vendor}
              >
                <MenuItem value="ctn">Ctn</MenuItem>
                <MenuItem value="box">Box</MenuItem>
              </Select>
            </FormControl>
          </Input>
        )}
          <Stack direction="row" width="100%" justifyContent="space-evenly">
            <Button variant="outlined" size="small" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" size="small" onClick={handleAdd}>
              Add
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddBatchNo;
